import { useEffect, useState } from 'react'
import {
  byValue,
  CLIENT_CONFIG_TRANSLATIONS_FILE_PATH,
  CLIENT_LINKS_FILE_PATH,
  CLIENT_TRANSLATIONS_FILE_PATH,
  combineTranslations,
  extend,
  fetchData
} from '../../utils'
import translationsBaseDataJson from '../../translations_new/translations.json'
import configTranslationsBaseDataJson from '../../translations_new/config-translations.json'
import { ErrorType, LoadingWrapper, WrapperProps } from '..'
import { CustomTranslationsWrapperNew } from './custom-translations-wrapper-new'
import { ConfigTranslationsData, CustomTranslationsData } from './types'
import { useErrorHandling } from '../../contexts'
import { TRANSLATIONS_ERROR } from '../errors/constants'

export const IntlProviderWrapperNew = ({ children }: WrapperProps) => {
  const [customTranslationsData, setCustomTranslationsData] = useState<
    CustomTranslationsData | undefined
  >(undefined)
  const { setErrorData } = useErrorHandling()

  useEffect(() => {
    const fetchDataFromJsonFile = async (url: string) => {
      return fetchData(url, {
        cache: 'no-store'
      })
    }

    const fetchTranslations = async () => {
      try {
        const clientTranslationsData = await fetchDataFromJsonFile(
          CLIENT_TRANSLATIONS_FILE_PATH
        )

        const commonTranslationsData = byValue(translationsBaseDataJson)

        const clientLinksData = await fetchDataFromJsonFile(
          CLIENT_LINKS_FILE_PATH
        )

        const clientConfigTranslationsData = await fetchDataFromJsonFile(
          CLIENT_CONFIG_TRANSLATIONS_FILE_PATH
        )

        const commonConfigTranslationsData = byValue(
          configTranslationsBaseDataJson
        )

        setCustomTranslationsData({
          translations: combineTranslations(
            commonTranslationsData,
            clientTranslationsData
          ),
          links: clientLinksData,
          configTranslations: extend(
            commonConfigTranslationsData,
            clientConfigTranslationsData,
            true
          ) as ConfigTranslationsData
        })
      } catch (e) {
        setErrorData({
          error: new Error(TRANSLATIONS_ERROR),
          errorType: ErrorType.FETCH_TRANSLATIONS
        })
      }
    }

    fetchTranslations()
  }, [setErrorData])

  return (
    <LoadingWrapper isLoading={customTranslationsData === undefined}>
      {customTranslationsData && (
        <CustomTranslationsWrapperNew
          customTranslationsData={customTranslationsData}
        >
          {children}
        </CustomTranslationsWrapperNew>
      )}
    </LoadingWrapper>
  )
}
